import { FormField } from 'pages/publications_v2/helpers/FieldHelper';

export function Azure({ isEditMode = false }) {
    return (
        <>
            <FormField
                name="clientId"
                label="Application (client) ID"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                }}
            />
            <FormField
                name="clientSecret"
                label="Client secret"
                props={{
                    disabled: isEditMode,
                    autoComplete: 'off',
                    'data-1p-ignore': '',
                    required: true,
                }}
            />
        </>
    );
}
